export const PRICING_ARCH_V2 = 'v2';
export const SELLER_TYPE = 'fulfillers';
